const cents = (value) => Math.round((Number(value) + Number.EPSILON) * 100);

export const paidAmount = (bills = []) =>
  bills.reduce((total, bill) => total + cents(bill.valorPago || 0), 0) / 100;

export const remainingAmount = (sale) =>
  Math.max(0, (cents(sale.valorTotal) - cents(sale.totalPago || 0)) / 100);

export const isSalePaid = (sale) =>
  sale.bills?.length > 0 &&
  sale.bills.some((bill) => cents(bill.valorPago || 0) > 0) &&
  remainingAmount(sale) === 0;
